import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {translate} from "react-i18next"
import {push} from "redux-little-router"

import {NotificationsCreators as Creators} from "./redux"
import NotificationList from "../../components/NotificationList"
import Button from "../../components/Button"
import Message from "../../components/Message"
import Breadcrumbs from "../../components/Breadcrumbs"
import {Container, Row, Col} from "../../components/Grid"
import Loader from "../../components/Loader"

import styles from "./styles.css"

class Notifications extends Component {
  static propTypes = {
    push: PropTypes.func.isRequired,
    notifications: PropTypes.arrayOf(PropTypes.object).isRequired,
    unreadCount: PropTypes.number.isRequired,
    fetching: PropTypes.bool.isRequired,
    error: PropTypes.string
  }

  render() {
    const {error, fetching, lang, notifications, t} = this.props

    const breadcrumbItems = [
      {title: `${t("Startseite")}`, href: `/${lang}/`},
      {title: `${t("Benachrichtigungen")}`, href: null}
    ]

    if (error) {
      return (
        <Message error>
          <p>
            <strong>{t("Es ist ein Fehler aufgetreten.")}</strong>
            <br />
            {error}
          </p>
        </Message>
      )
    }

    return (
      <div className={styles.Wrapper}>
        <Loader active={fetching} />
        <div className="wp-content color-black">
          <Container>
            <Row className="row-fluid">
              <Col xl={10}>
                <div className="text_column">
                  <h1 className="headline">{t("Benachrichtigungen")}</h1>
                  <p className="description no-margin">
                    {t(
                      "Hier findest du all deine Benachrichtigungen über neue Inhalte der abat+ Lernplattform."
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="container-breadcrumbs">
          <Container>
            <Row className="row-fluid">
              <Breadcrumbs items={breadcrumbItems} theme="black" />
            </Row>
          </Container>
        </div>
        <Container className={styles.Content}>
          <Row justifyContent="center">
            <Col lg={8}>
              {notifications.length > 0 && (
                <div className={styles.Buttons}>
                  <Button
                    size="small"
                    theme="dark"
                    alignment="right"
                    onClick={() => this.props.readAllNotifications()}
                    className="button--read-all"
                  >
                    {t("Alle als gelesen markieren")}
                  </Button>
                </div>
              )}
              <div className="card">
                <NotificationList
                  notifications={notifications}
                  onClick={(path, notification) => {
                    // read notification if not already done
                    if (!notification.read_at) {
                      this.props.readNotification(notification.id)
                    }

                    // redirect to destination
                    this.props.push(path)
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state.notifications,
    lang: state.app.lang
  }
}
const mapDispatchToProps = dispatch => {
  return {
    push: location => dispatch(push(location)),
    readNotification: id => dispatch(Creators.readNotificationRequest(id)),
    readAllNotifications: () => dispatch(Creators.readNotificationsAllRequest())
  }
}
Notifications = connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications)
export default translate()(Notifications)

export {reducer} from "./redux"
export {default as sagas} from "./sagas"



// WEBPACK FOOTER //
// ./src/containers/Notifications/index.js